import React from "react";
import FolioTable from "./FolioTable";

/**
 * Family wrapper for FolioTable
 * Reuses individual FolioTable logic, just allows separate modal handlers
 */
export default function FamilyFolioTable({
  pan,
  onOpenFolioModal,
  onOpenSchemeModal,
  onOpenTxnModal,
}) {
  return (
    <FolioTable
      pan={pan}
      onOpenModal={onOpenFolioModal}       // Folio detail modal
      onOpenSchemeModal={onOpenSchemeModal} // Scheme detail modal
      onOpenTxnModal={onOpenTxnModal}       // Transaction detail modal
    />
  );
}
